module.exports = __webpack_public_path__ + "static/img/HESSAPP.e25aba99.png";